export default "__VITE_ASSET__DAR9XzRU__"